var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisibility(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.9999C9.10457 9.9999 10 9.10447 10 7.9999C10 6.89533 9.10457 5.9999 8 5.9999C6.89543 5.9999 6 6.89533 6 7.9999C6 9.10447 6.89543 9.9999 8 9.9999Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.531404 8.4722C0.413913 8.16689 0.414015 7.82841 0.531688 7.52316C1.68702 4.52621 4.59464 2.3999 7.99887 2.3999C11.4048 2.3999 14.3136 4.52831 15.4678 7.5276C15.5853 7.83292 15.5852 8.1714 15.4675 8.47664C14.3121 11.4736 11.4045 13.5999 8.0003 13.5999C4.59438 13.5999 1.68558 11.4715 0.531404 8.4722ZM11.2003 7.9999C11.2003 9.76721 9.76761 11.1999 8.0003 11.1999C6.23299 11.1999 4.8003 9.76721 4.8003 7.9999C4.8003 6.23259 6.23299 4.7999 8.0003 4.7999C9.76761 4.7999 11.2003 6.23259 11.2003 7.9999Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibility);
export default __webpack_public_path__ + "static/media/Visibility.cc1df4cf4831d03e42b46c07af0e4b9c.svg";
export { ForwardRef as ReactComponent };